export default __webpack_public_path__ + "static/distance-9423ea85ebcdb49c3e05ea3b91fb9239.png";